import { createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_f_announce_red.svg'
import _imports_1 from '@/app/ui/assets/svg/frame-image.svg'


const _hoisted_1 = { class: "grid grid-rows-[auto_1fr]" }
const _hoisted_2 = { class: "flex items-center gap-2 mb-4 p-4 border-b border-gray-lp-1400" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "p-2 rounded-lg border border-red-lp-100 bg-red-lp-50" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    class: "w-5"
  })
], -1)
const _hoisted_4 = { class: "text-black-lp-300 text-base font-bold" }
const _hoisted_5 = { class: "text-gray-lp-600 text-sm" }
const _hoisted_6 = { class: "grid grid-cols-2 gap-8 place-items-center p-4 bg-gray-lp-100 rounded-lg" }
const _hoisted_7 = { class: "mt-3" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "space-y-4" }
const _hoisted_10 = { class: "flex flex-col gap-2" }
const _hoisted_11 = { class: "flex flex-row" }
const _hoisted_12 = { class: "w-full text-start font-semibold" }
const _hoisted_13 = { class: "pl-6 pr-16 pb-6" }
const _hoisted_14 = /*#__PURE__*/_createVNode("hr", { class: "bg-gray-lp-1400 my-3" }, null, -1)
const _hoisted_15 = { class: "text-gray-lp-600 text-xs mb-4" }
const _hoisted_16 = { class: "text-gray-lp-300 text-xs font-semibold mb-2 list-disc" }
const _hoisted_17 = { class: " pl-5 text-gray-lp-600 text-xs space-y-1" }
const _hoisted_18 = { class: "text-gray-lp-600 flex items-center gap-2 list-disc mb-1 " }
const _hoisted_19 = { class: "list-disc pl-4" }
const _hoisted_20 = { class: "text-black-lp-300 text-xs font-semibold mb-3" }
const _hoisted_21 = { class: "space-y-3 mx-5" }
const _hoisted_22 = { class: "font-semibold text-xs text-white px-6 pt-4 pb-2" }
const _hoisted_23 = /*#__PURE__*/_createVNode("hr", { class: "border border-gray-lp-200 mx-6 opacity-50 " }, null, -1)
const _hoisted_24 = { class: "flex flex-row justify-between items-start gap-4 px-6 py-4" }
const _hoisted_25 = { class: "text-white text-10px font-medium max-w-200px flex-1" }
const _hoisted_26 = { class: "relative h-28" }
const _hoisted_27 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "absolute inset-0 w-full p-2",
  alt: "frame"
}, null, -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "absolute bottom-0 w-full p-2",
  style: {"transform":"rotate(180deg)"},
  alt: "frame"
}, null, -1)
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { class: "space-y-4" }
const _hoisted_31 = { class: "flex flex-col gap-2" }
const _hoisted_32 = { class: "flex flex-row" }
const _hoisted_33 = { class: "w-full text-start font-semibold" }
const _hoisted_34 = { class: "pl-6 pr-16 pb-6" }
const _hoisted_35 = /*#__PURE__*/_createVNode("hr", { class: "bg-gray-lp-1400 my-3" }, null, -1)
const _hoisted_36 = { class: "text-gray-lp-600 text-xs mb-4" }
const _hoisted_37 = { class: "text-gray-lp-300 text-xs font-semibold mb-2 list-disc" }
const _hoisted_38 = { class: " pl-5 text-gray-lp-600 text-xs space-y-1" }
const _hoisted_39 = { class: "text-gray-lp-600 flex items-center gap-2 list-disc mb-1" }
const _hoisted_40 = { class: "list-disc pl-4" }
const _hoisted_41 = { class: "text-black-lp-300 text-xs font-semibold mb-3" }
const _hoisted_42 = { class: "space-y-3 mx-5" }
const _hoisted_43 = { class: "font-semibold text-xs text-white px-6 pt-4 pb-2" }
const _hoisted_44 = /*#__PURE__*/_createVNode("hr", { class: "border border-gray-lp-200 mx-6 opacity-50" }, null, -1)
const _hoisted_45 = { class: "flex flex-row items-start justify-between px-6 py-4" }
const _hoisted_46 = { class: "text-white text-10px font-medium max-w-200px flex-1" }
const _hoisted_47 = { class: "relative h-28" }
const _hoisted_48 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "absolute inset-0 w-full p-2",
  alt: "frame"
}, null, -1)
const _hoisted_49 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "absolute bottom-0 w-full p-2",
  style: {"transform":"rotate(180deg)"},
  alt: "frame"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_GuideCarouselModal = _resolveComponent("GuideCarouselModal")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", null, [
        _createVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('pusatResolusi.confused')), 1),
        _createVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('pusatResolusi.makeSure')), 1)
      ])
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode("div", {
        class: ["py-3 px-2 w-full text-sm focus:outline-none transition-colors duration-200 cursor-pointer text-center", {
          'text-black-lp-300 bg-white font-semibold shadow rounded-lg':
            _ctx.activeTab === 'shipping',
          'text-gray-lp-2600 font-semibold': _ctx.activeTab !== 'shipping'
        }],
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeTab = 'shipping'))
      }, _toDisplayString(_ctx.$t('pusatResolusi.create.pengirimanNbantuan')), 3),
      _createVNode("div", {
        class: ["py-3 px-2 w-full whitespace-nowrap text-sm focus:outline-none transition-colors duration-200 cursor-pointer text-center", {
          'text-black-lp-300 bg-white font-medium shadow rounded-lg':
            _ctx.activeTab === 'system',
          'text-gray-lp-2600': _ctx.activeTab !== 'system'
        }],
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.activeTab = 'system'))
      }, _toDisplayString(_ctx.$t('pusatResolusi.create.sistemNbandingPinalti')), 3)
    ]),
    _createVNode("div", _hoisted_7, [
      (_ctx.activeTab === 'shipping')
        ? (_openBlock(), _createBlock("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, [
              _createVNode("div", _hoisted_10, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.contentGuideList, (guide, index) => {
                  return (_openBlock(), _createBlock(_component_Accordion, {
                    key: index,
                    class: "shadow text-sm mb-2 text-gray-lp-300 border-none rounded-lg",
                    borderHeader: "border-none",
                    chevrons: ['chevron-up', 'chevron-down'],
                    titleFontWeight: "font-bold"
                  }, {
                    header: _withCtx(() => [
                      _createVNode("div", _hoisted_11, [
                        _createVNode("span", _hoisted_12, _toDisplayString(_ctx.$t(guide.title)), 1),
                        (guide.case_type)
                          ? (_openBlock(), _createBlock("div", {
                              key: 0,
                              class: ["rounded-full px-1 py-0.5 text-white text-xs flex-none whitespace-nowrap", `${_ctx.mapBackgroundStyle(guide.case_type)}`]
                            }, _toDisplayString(_ctx.mapCaseTypeLabel(guide.case_type)), 3))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createVNode("div", _hoisted_13, [
                        _hoisted_14,
                        _createVNode("div", null, [
                          _createVNode("p", _hoisted_15, _toDisplayString(_ctx.$t(guide.content )), 1),
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(guide.status, (status, statusIndex) => {
                            return _withDirectives((_openBlock(), _createBlock("div", {
                              class: "mb-4",
                              key: statusIndex
                            }, [
                              _createVNode("li", _hoisted_16, _toDisplayString(_ctx.$t(status.title)), 1),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(status.list, (listStatus, index) => {
                                return (_openBlock(), _createBlock("div", { key: index }, [
                                  _createVNode("ul", _hoisted_17, [
                                    _createVNode("li", _hoisted_18, _toDisplayString(_ctx.$t(listStatus)), 1)
                                  ])
                                ]))
                              }), 128))
                            ], 512)), [
                              [_vShow, status.list.length > 0]
                            ])
                          }), 128)),
                          _createVNode("ul", _hoisted_19, [
                            _createVNode("li", _hoisted_20, [
                              _createTextVNode(_toDisplayString(_ctx.$t('pusatResolusi.create.attachment')) + " ", 1),
                              _createVNode("span", {
                                class: "text-red-lp-100 border-b border-red-lp-100 cursor-pointer text-xs font-semibold",
                                onClick: ($event: any) => (_ctx.openCarousel(guide))
                              }, _toDisplayString(_ctx.$t('pusatResolusi.create.seeDetail')), 9, ["onClick"])
                            ])
                          ]),
                          _createVNode("div", _hoisted_21, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(guide.carousel_list, (carousel, carouselIndex) => {
                              return (_openBlock(), _createBlock("div", {
                                key: carouselIndex,
                                class: "bg-blue-lp-100 rounded-lg overflow-hidden"
                              }, [
                                _createVNode("p", _hoisted_22, _toDisplayString(_ctx.$t(carousel.title)), 1),
                                _hoisted_23,
                                _createVNode("div", _hoisted_24, [
                                  _createVNode("p", _hoisted_25, _toDisplayString(_ctx.$t(carousel.description)), 1),
                                  _createVNode("div", _hoisted_26, [
                                    _createVNode("img", {
                                      src: carousel.image_url,
                                      class: "w-36 h-28 rounded-lg object-contain",
                                      alt: "image_lampiran"
                                    }, null, 8, ["src"]),
                                    _hoisted_27,
                                    _hoisted_28
                                  ])
                                ])
                              ]))
                            }), 128))
                          ])
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.activeTab === 'system')
        ? (_openBlock(), _createBlock("div", _hoisted_29, [
            _createVNode("div", _hoisted_30, [
              _createVNode("div", _hoisted_31, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.contentGuideListSystem, (guide, index) => {
                  return (_openBlock(), _createBlock(_component_Accordion, {
                    key: index,
                    class: "shadow text-sm mb-2 text-gray-lp-300 border-none rounded-lg",
                    borderHeader: "border-none",
                    chevrons: ['chevron-up', 'chevron-down'],
                    titleFontWeight: "font-bold"
                  }, {
                    header: _withCtx(() => [
                      _createVNode("div", _hoisted_32, [
                        _createVNode("span", _hoisted_33, _toDisplayString(_ctx.$t(guide.title)), 1),
                        (guide.case_type)
                          ? (_openBlock(), _createBlock("div", {
                              key: 0,
                              class: ["rounded-full px-1 py-0.5 text-white text-xs flex-none whitespace-nowrap", `${_ctx.mapBackgroundStyle(guide.case_type)}`]
                            }, _toDisplayString(_ctx.mapCaseTypeLabel(guide.case_type)), 3))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createVNode("div", _hoisted_34, [
                        _hoisted_35,
                        _createVNode("div", null, [
                          _createVNode("p", _hoisted_36, _toDisplayString(_ctx.$t(guide.content)), 1),
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(guide.status, (status, statusIndex) => {
                            return _withDirectives((_openBlock(), _createBlock("div", {
                              class: "mb-4",
                              key: statusIndex
                            }, [
                              _createVNode("li", _hoisted_37, _toDisplayString(_ctx.$t(status.title)), 1),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(status.list, (listStatus, index) => {
                                return (_openBlock(), _createBlock("div", { key: index }, [
                                  _createVNode("ul", _hoisted_38, [
                                    _createVNode("li", _hoisted_39, _toDisplayString(_ctx.$t(listStatus)), 1)
                                  ])
                                ]))
                              }), 128))
                            ], 512)), [
                              [_vShow, status.list.length > 0]
                            ])
                          }), 128)),
                          _createVNode("ul", _hoisted_40, [
                            _createVNode("li", _hoisted_41, [
                              _createTextVNode(_toDisplayString(_ctx.$t('pusatResolusi.create.attachment')) + " ", 1),
                              _createVNode("span", {
                                class: "text-red-lp-100 border-b border-red-lp-100 cursor-pointer text-xs font-semibold",
                                onClick: ($event: any) => (_ctx.openCarousel(guide))
                              }, _toDisplayString(_ctx.$t('pusatResolusi.create.seeDetail')), 9, ["onClick"])
                            ])
                          ]),
                          _createVNode("div", _hoisted_42, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(guide.carousel_list, (carousel, carouselIndex) => {
                              return (_openBlock(), _createBlock("div", {
                                key: carouselIndex,
                                class: "bg-blue-lp-100 rounded-lg overflow-hidden"
                              }, [
                                _createVNode("p", _hoisted_43, _toDisplayString(_ctx.$t(carousel.title)), 1),
                                _hoisted_44,
                                _createVNode("div", _hoisted_45, [
                                  _createVNode("p", _hoisted_46, _toDisplayString(_ctx.$t(carousel.description)), 1),
                                  _createVNode("div", _hoisted_47, [
                                    _createVNode("img", {
                                      src: carousel.image_url,
                                      class: "w-36 h-28 rounded-lg object-contain",
                                      alt: "image_lampiran"
                                    }, null, 8, ["src"]),
                                    _hoisted_48,
                                    _hoisted_49
                                  ])
                                ])
                              ]))
                            }), 128))
                          ])
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_GuideCarouselModal, {
      show: _ctx.showCarousel,
      guide: _ctx.selectedGuide,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => (_ctx.showCarousel = $event))
    }, null, 8, ["show", "guide"])
  ]))
}